import { render, staticRenderFns } from "./AllReservationsPage.vue?vue&type=template&id=2d5262ee&scoped=true&"
import script from "./AllReservationsPage.vue?vue&type=script&lang=js&"
export * from "./AllReservationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5262ee",
  null
  
)

export default component.exports